export default __webpack_public_path__ + "static/media/ge.96960385.svg";